/**
 * PDP purchase options — mixed-variant cart add (items[] API).
 * Capture-phase submit intercept; legacy single-variant path untouched.
 */
(function () {
  'use strict';

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function getCartAddUrl() {
    var url = window.routes && window.routes.cart_add_url;
    if (!url) return null;
    return url.indexOf('.js') !== -1 ? url : url + '.js';
  }

  function getCartSectionsUrl() {
    var url = (window.routes && window.routes.cart_url) || '/cart';
    return url.charAt(0) === '/' ? url : '/' + url;
  }

  function getCartComponent() {
    return qs('cart-drawer') || qs('cart-notification');
  }

  function showFormError(form, message) {
    var el = qs('[data-pdp-form-error]', form);
    if (!el) return;
    var text =
      typeof message === 'string'
        ? message
        : message && (message.description || message.message)
          ? message.description || message.message
          : 'Unable to add this item to your cart. Please try again.';
    el.hidden = false;
    el.textContent = text;
  }

  function hideFormError(form) {
    var el = qs('[data-pdp-form-error]', form);
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
  }

  function setSubmitLoading(form, loading) {
    var submitBtn = qs('[type="submit"]', form);
    var stickyBtn = qs('[data-pdp-sticky-submit]');

    [submitBtn, stickyBtn].forEach(function (btn) {
      if (!btn) return;
      btn.classList.toggle('loading', loading);
      if (loading) btn.setAttribute('aria-disabled', 'true');
      else if (!btn.disabled) btn.removeAttribute('aria-disabled');
    });
  }

  function consolidateItems(items) {
    var map = Object.create(null);
    items.forEach(function (item) {
      var id = parseInt(item.id, 10);
      if (Number.isNaN(id) || id < 1) return;
      var key = String(id);
      if (!map[key]) map[key] = { id: id, quantity: 0 };
      map[key].quantity += item.quantity || 1;
    });
    return Object.keys(map).map(function (key) {
      return map[key];
    });
  }

  function parseJsonResponse(response) {
    return response.text().then(function (text) {
      var data = {};
      if (text) {
        try {
          data = JSON.parse(text);
        } catch (err) {
          throw new Error(
            text.trim().slice(0, 240) || 'The cart returned an unexpected response. Please try again.'
          );
        }
      }

      if (!response.ok && !data.status) {
        data.status = response.status;
        data.message = data.message || data.description || 'Unable to add items to your cart.';
      }

      return data;
    });
  }

  function getSectionMarkup(sections, sectionId) {
    if (!sections || !sectionId) return null;
    if (sections[sectionId]) return sections[sectionId];

    var matchKey = Object.keys(sections).find(function (key) {
      return key === sectionId || key.indexOf(sectionId) !== -1;
    });

    return matchKey ? sections[matchKey] : null;
  }

  function extractSectionInnerHTML(html, selectorCandidates) {
    if (!html || typeof html !== 'string') return null;

    var doc;
    try {
      doc = new DOMParser().parseFromString(html, 'text/html');
    } catch (err) {
      return null;
    }

    var candidates = selectorCandidates && selectorCandidates.length ? selectorCandidates : ['.shopify-section'];

    for (var i = 0; i < candidates.length; i++) {
      var node = doc.querySelector(candidates[i]);
      if (node) return node.innerHTML;
    }

    return null;
  }

  function applySectionUpdate(target, html, selectorCandidates) {
    if (!target) return false;
    var inner = extractSectionInnerHTML(html, selectorCandidates);
    if (inner == null) return false;
    target.innerHTML = inner;
    return true;
  }

  function fetchCartSections(cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') {
      return Promise.reject(new Error('Cart drawer sections unavailable'));
    }

    var sectionIds = cart
      .getSectionsToRender()
      .map(function (section) {
        return section.id;
      })
      .join(',');

    var sectionsUrl = getCartSectionsUrl();
    var joiner = sectionsUrl.indexOf('?') >= 0 ? '&' : '?';
    var url = sectionsUrl + joiner + 'sections=' + encodeURIComponent(sectionIds);

    return fetch(url).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to refresh cart drawer.');
      }
      return response.json();
    });
  }

  function hasUsableDrawerSection(sections) {
    var drawerHtml = getSectionMarkup(sections, 'cart-drawer');
    return !!(drawerHtml && extractSectionInnerHTML(drawerHtml, ['#CartDrawer', 'cart-drawer #CartDrawer', '.drawer__inner', '.shopify-section']));
  }

  function ensureCartSections(cart, addResponse) {
    var sections = addResponse && addResponse.sections;
    if (sections && hasUsableDrawerSection(sections)) {
      return Promise.resolve(sections);
    }
    return fetchCartSections(cart);
  }

  function openCartDrawer(cart) {
    if (!cart || typeof cart.open !== 'function') return;

    setTimeout(function () {
      var overlay = cart.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', cart.close.bind(cart));
      }
      cart.open(document.activeElement);
    }, 0);
  }

  function applyDrawerSectionUpdate(html) {
    var cartDrawerEl = document.querySelector('#CartDrawer');
    if (!html || !cartDrawerEl) return false;

    var fullDrawerInner = extractSectionInnerHTML(html, ['#CartDrawer']);
    if (fullDrawerInner != null) {
      cartDrawerEl.innerHTML = fullDrawerInner;
      return true;
    }

    var drawerInnerTarget = cartDrawerEl.querySelector('.drawer__inner');
    var drawerInnerContent = extractSectionInnerHTML(html, ['.drawer__inner', 'cart-drawer .drawer__inner', '.shopify-section .drawer__inner']);
    if (drawerInnerTarget && drawerInnerContent != null) {
      drawerInnerTarget.innerHTML = drawerInnerContent;
      return true;
    }

    var sectionContent = extractSectionInnerHTML(html, ['cart-drawer', '.shopify-section']);
    if (sectionContent != null) {
      cartDrawerEl.innerHTML = sectionContent;
      return true;
    }

    return false;
  }

  function applyBubbleSectionUpdate(html) {
    var bubbleTarget = document.getElementById('cart-icon-bubble');
    if (!html || !bubbleTarget) return false;

    return applySectionUpdate(bubbleTarget, html, ['.shopify-section', '#cart-icon-bubble']);
  }

  function renderMixedCartUI(cart, addResponse) {
    if (!cart) return Promise.resolve(false);

    return ensureCartSections(cart, addResponse).then(function (sections) {
      if (!sections) return false;

      var updated = false;

      if (applyDrawerSectionUpdate(getSectionMarkup(sections, 'cart-drawer'))) {
        updated = true;
      }

      if (applyBubbleSectionUpdate(getSectionMarkup(sections, 'cart-icon-bubble'))) {
        updated = true;
      }

      if (cart.tagName === 'CART-DRAWER') {
        var drawerInner = cart.querySelector('.drawer__inner');
        if (drawerInner && drawerInner.classList.contains('is-empty')) {
          drawerInner.classList.remove('is-empty');
        }
        cart.classList.remove('is-empty');
      }

      if (updated) {
        openCartDrawer(cart);
      }

      return updated;
    });
  }

  function addMixedItemsToCart(items) {
    var cart = getCartComponent();
    var cartAddUrl = getCartAddUrl();
    var normalizedItems = consolidateItems(items);

    if (!cartAddUrl || typeof fetchConfig !== 'function') {
      return Promise.reject(new Error('Cart add unavailable'));
    }

    if (!normalizedItems.length) {
      return Promise.reject(new Error('No valid variants selected'));
    }

    var payload = {
      items: normalizedItems,
    };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',');
      payload.sections_url = getCartSectionsUrl();
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(payload);

    return fetch(cartAddUrl, config).then(parseJsonResponse);
  }

  function handleMixedSubmit(event) {
    var form = event.currentTarget;
    if (!form || !window.PdpPurchaseOptions) return;
    if (!PdpPurchaseOptions.isMixedModeActive()) return;

    if (!PdpPurchaseOptions.isReady()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof PdpPurchaseOptions.scrollIntoView === 'function') {
        PdpPurchaseOptions.scrollIntoView();
      }
      return;
    }

    var items = PdpPurchaseOptions.getCartItems();
    if (!items || !items.length) return;

    var submitBtn = qs('[type="submit"]', form);
    if (submitBtn && (submitBtn.disabled || submitBtn.getAttribute('aria-disabled') === 'true')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    hideFormError(form);
    setSubmitLoading(form, true);

    addMixedItemsToCart(items)
      .then(function (response) {
        if (response.status) {
          showFormError(form, response.description || response.message);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'pdp-purchase-options-cart',
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          return;
        }

        hideFormError(form);

        var cart = getCartComponent();
        var normalizedItems = consolidateItems(items);
        var addedQuantity = normalizedItems.reduce(function (total, item) {
          return total + (item.quantity || 0);
        }, 0);
        var addedItems = [];
        if (window.PdpPurchaseOptions && typeof window.PdpPurchaseOptions.getAddedItemsPreview === 'function') {
          addedItems = window.PdpPurchaseOptions.getAddedItemsPreview();
        }

        return renderMixedCartUI(cart, response).then(function (rendered) {
          if ((!addedItems || !addedItems.length) && window.PdpCartConfirmation) {
            addedItems = window.PdpCartConfirmation.buildAddedItemsFromResponse(response);
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            try {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'pdp-purchase-options-cart',
                addedQuantity: addedQuantity,
                cartData: response,
                addedItems: addedItems,
              });
            } catch (err) {
              console.warn('[pdp-purchase-options-cart] cartUpdate publish failed', err);
            }
          }

          if (rendered) return;

          if (window.routes && window.routes.cart_url) {
            window.location = window.routes.cart_url;
          }
        });
      })
      .catch(function (err) {
        console.warn('[pdp-purchase-options-cart] add to cart failed', err);
        showFormError(
          form,
          err && err.message ? err.message : 'Network error — check your connection and try again.'
        );
      })
      .finally(function () {
        setSubmitLoading(form, false);
      });
  }

  function initMixedCartForm(form) {
    if (!form || form.dataset.pdpMixedCartInit === 'true') return;
    if (!qs('[data-pdp-purchase-options]', form.closest('[data-pdp-hero], .pdp-hero') || document)) return;

    form.dataset.pdpMixedCartInit = 'true';
    var ac = new AbortController();

    form.addEventListener('submit', handleMixedSubmit, { capture: true, signal: ac.signal });

    form._pdpMixedCartCleanup = function () {
      ac.abort();
      delete form.dataset.pdpMixedCartInit;
    };
  }

  function initScope(scope) {
    var root = scope || document;
    var hero = qs('[data-pdp-hero], .pdp-hero', root) || (root.matches && root.matches('[data-pdp-hero], .pdp-hero') ? root : null);
    var form =
      qs('#pdp-product-form', hero || root) ||
      qs('form[action*="/cart/add"]', hero || root) ||
      qs('#pdp-product-form', root) ||
      qs('form[action*="/cart/add"]', root);

    if (form) initMixedCartForm(form);
  }

  if (document.readyState !== 'loading') initScope(document);
  else document.addEventListener('DOMContentLoaded', function () { initScope(document); }, { once: true });

  document.addEventListener('shopify:section:load', function (event) {
    initScope(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var form =
      qs('#pdp-product-form', event.target) ||
      qs('form[action*="/cart/add"]', event.target);
    if (form && typeof form._pdpMixedCartCleanup === 'function') {
      form._pdpMixedCartCleanup();
    }
  });
})();
